var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivePreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#0078D4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.333.5h13.334a.833.833 0 0 1 .833.833v13.334a.833.833 0 0 1-.833.833H1.333a.833.833 0 0 1-.833-.833V1.333A.833.833 0 0 1 1.333.5Zm1.672 8.92c.074.077.15.16.236.257l.056.062.015.016c.808.899 2.307 2.567 4.77 2.567 2.54 0 4.151-1.729 5.029-2.67l.018-.02.002-.002.196-.208.001-.001a1.833 1.833 0 0 0 0-2.53l-.197-.21V6.68l-.025-.026c-.877-.94-2.486-2.665-5.024-2.665-2.455 0-3.95 1.658-4.762 2.558l-.023.025-.004.005c-.107.119-.2.222-.287.313l-.001.001a1.833 1.833 0 0 0 0 2.528Z",
    stroke: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.167 5.49a2.667 2.667 0 1 0 0 5.334 2.667 2.667 0 0 0 0-5.333Zm0 3.667a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePreview);
export default __webpack_public_path__ + "static/media/active_preview.b6469a73.svg";
export { ForwardRef as ReactComponent };